import React from 'react';
import './CollapsablePanel.css';
import { normalizeClassName } from '../../render/renderUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';

export function CollapsablePanel({
    isCollapsed,
    toggleCollapse,
    children,
    extraClasses = [],
    orientation = 'lateral',
    hideToggelWhenCollapsed = false
}: {
    isCollapsed: boolean,
    toggleCollapse: () => void,
    children: React.ReactNode,
    extraClasses?: string[],
    orientation?: 'lateral' | 'bottom',
    hideToggelWhenCollapsed?: boolean

}) {

    const classes = orientation === 'lateral' ? ['lateral-collapsable-panel'] : ['bottom-collapsable-panel'];
    if (isCollapsed) classes.push('collapsed');

    return (
        <div className={normalizeClassName(classes.concat(extraClasses))}>
            {(!hideToggelWhenCollapsed || !isCollapsed) &&
                <button
                    onClick={toggleCollapse}
                    className='ryd-collapsable-panel-toggle'
                >
                    <FontAwesomeIcon icon={orientation === 'bottom' ? faChevronDown : faChevronRight} />
                </button>
            }
            {!isCollapsed && children}
        </div>
    );
}